// @ts-ignore
import { getIsContentManager } from 'platform-components/src/components/user/selectors';
import { useActions } from 'platform-components/src/utils/hooks/useActions';
import React from 'react';
import { useSelector } from 'react-redux';
import { useMedia } from 'react-use';
import cn from 'classnames';
import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { PROBLEM_RUN_QUERY_MOBILE } from 'common.components/problem-run/constants';
import { ProblemRun } from 'common.components/problem-run/problem-run';
import { actions } from 'store/problems-view/actions';
import * as problemsViewSelectors from 'store/problems-view/selectors';

import { ProblemViewProblemBarContainer } from '../__problem-bar/problem-view__problem-bar.container';

import './problem-view__problem-run.scss';

const Component = ({ mix }: { mix?: string }) => {
    const isMobile = useMedia(PROBLEM_RUN_QUERY_MOBILE);

    const isAnswered = useSelector(problemsViewSelectors.getIsAnswered);
    const problemAttempt = useSelector(problemsViewSelectors.getProblemAttempt);
    const problemLink = useSelector(lessonViewSelectors.getSelectedProblemLink);
    const selectedProblemId = useSelector(problemsViewSelectors.getSelectedProblemId);
    const shouldShowCorrectAnswers = useSelector(problemsViewSelectors.getShouldShowCorrectAnswers);
    const shouldShowProblemId = useSelector(getIsContentManager);

    const { setMarkerAnswer } = useActions({
        setMarkerAnswer: actions.setMarkerAnswer,
    });

    const readonly = isMobile || isAnswered || shouldShowCorrectAnswers;

    return (
        <ProblemRun
            isAnswered={isAnswered}
            mix={cn(mix, 'problem-view__problem-run')}
            problemAttempt={problemAttempt}
            problemLink={problemLink}
            readonly={readonly}
            selectedProblemId={selectedProblemId}
            setMarkerAnswer={setMarkerAnswer}
            shouldShowCorrectAnswers={shouldShowCorrectAnswers}
            shouldShowProblemId={shouldShowProblemId}
        >
            <ProblemViewProblemBarContainer />
        </ProblemRun>
    );
};

export const ProblemViewProblemRunContainer = React.memo(Component);
